
<script>
/**
 * Dashboard Component
 */
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    route: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      routeData: null,
      handler: null,
    };
  },
  methods: {
    modalShown() {
      this.handler = () => {
        this.$bvModal.hide(this.name);
      };
      window.addEventListener('popstate', this.handler, false);

      this.routeData = this.$router.resolve(this.route);
      window.history.pushState({}, null, this.routeData.href);
    },
    openRoute(newTab = false) {
      window.removeEventListener('popstate', this.handler, false);

      if (newTab) {
        window.open(this.$router.resolve(this.route).href, '_blank');
      } else {
        this.$router.replace(this.route);
      }
    },
    modalHidden() {
      window.removeEventListener('popstate', this.handler, false);
      if (this.routeData != null) {
        if (window.location.href.includes(this.routeData.href)) {
          window.history.back();
        }
      }
      this.$emit('modal-closed');
    },
  },
};
</script>

<template>
  <b-modal
    :id="name"
    size="xl"
    ok-only
    hide-footer
    dialog-class="xxl-modal"
    @shown="modalShown()"
    @hide="modalHidden()"
  >
    <template #modal-header="{ close }">
      <!-- Emulate built in modal header close button action -->
      <span
        class="custom-link"
        href="#"
        @click.left.prevent="openRoute(false)"
        @click.middle.prevent="openRoute(true)"
      >
        {{ title }}
      </span>
      <button type="button" aria-label="Close" class="close" @click="close">
        ×
      </button>
    </template>

    <slot></slot>
  </b-modal>
</template>